import { LuxButton, SectionHeading } from "../common/Primitives";
import { Reveal, RevealImage } from "../motion/Reveal";
import { IMG } from "../../config/site";
import { useUI } from "../../context/UIContext";

export const CoBranding = () => {
  const { openEnquiry, openPanel } = useUI();
  return (
    <section id="hotels" data-testid="cobranding-section" className="bg-[#E3D2B4]">
      <div className="mx-auto grid max-w-[1600px] lg:grid-cols-[0.95fr_1.5fr_0.55fr]">
        <div className="px-5 py-24 sm:px-8 lg:py-32 lg:pl-12 lg:pr-10">
          <SectionHeading eyebrow="Hotel Co-Branding" lines={["Your Identity.", "Our Craft."]} />
          <Reveal delay={0.15}>
            <p className="body-lux mt-8 max-w-sm !text-[#5f584f]">
              We work with hospitality partners to explore bespoke bottle presentations that complement their brand, setting, and guest experience.
            </p>
            <div className="mt-10 flex flex-col items-start gap-5">
              <LuxButton variant="line-dark" arrow onClick={() => openEnquiry("Hotel co-branding / private label")} data-testid="cobrand-discuss-btn">Discuss a co-branded bottle</LuxButton>
              <button type="button" onClick={() => openPanel("cobrand")} data-testid="cobrand-learn-btn" className="link-lux text-[11px] font-bold uppercase tracking-[0.22em] text-[#8C6A3C]">How co-branding works</button>
            </div>
          </Reveal>
        </div>
        <div className="relative">
          <RevealImage src={IMG.cobrand} alt="Three identical TOYAM glass bottles on a marble hotel table: centre bottle labelled TOYAM Alkaline Water, two with sample 'Your hotel logo here' labels"
            className="h-[380px] sm:h-[480px] lg:h-full lg:min-h-[600px]" />
          <span className="absolute bottom-4 left-4 bg-[#21170F]/75 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.24em] text-[#E8D6B7] backdrop-blur" data-testid="cobrand-concept-tag">
            Visual concept · sample labels
          </span>
        </div>
        <div className="flex items-center bg-[#21170F] px-8 py-14 lg:px-8">
          <Reveal>
            <span className="block h-px w-10 bg-[#B18A4A]" aria-hidden="true" />
            <p className="font-serif-lux mt-6 text-[1.7rem] italic leading-snug text-[#F8F3E9]">A memorable detail for an unforgettable guest experience.</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
